const {
  DIALOG_PROP_DEFS,
  pickDialogProps,
  hasNamedSlot,
  shouldShowDialogHeader,
  mergeDialogContentClass
} = require('./dialog-props')

export default {
  name: 'st-dialog',
  inheritAttrs: false,
  props: Object.assign({
    label: {
      type: String,
      default: ''
    },
    showClose: Boolean
  }, DIALOG_PROP_DEFS),
  computed: {
    dialogBindings () {
      const props = pickDialogProps(this.$props)
      delete props.value
      props.contentClass = mergeDialogContentClass(props.contentClass)
      return Object.assign({}, this.$attrs, props)
    },
    dialogListeners () {
      const listeners = Object.assign({}, this.$listeners)
      delete listeners.input
      return listeners
    },
    dialogValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    hasSlot (name) {
      return hasNamedSlot(this.$slots, this.$scopedSlots, name)
    },
    isHeaderVisible () {
      return shouldShowDialogHeader(this.label, this.showClose, this.hasSlot('header'))
    },
    close () {
      this.dialogValue = false
    }
  }
}
